(() => {
  // Dynamic cart-drawer upsell.
  // - Cart has no bundle         -> offer the Calm & Bloom 3-pack (best value entry).
  // - Cart already has a 3-pack  -> offer the full 5-pack instead (upgrade, no duplicates).
  // - Cart already has a 5-pack  -> hide the upsell (nothing better to offer).
  const THREE_PACK = {
    eyebrow: '3-filter bundle · Best value',
    title: 'Bundle Calm & Bloom 3-pack',
    benefit: 'Get 3 filters together and save more on your shower routine.',
    price: '<span class="money">Dhs. 321.30</span>',
    compare: '<span class="money">Dhs. 357.00</span>',
    saving: 'Save <span class="money">Dhs. 35.70</span>',
    image: 'https://cdn.shopify.com/s/files/1/0913/2880/7286/files/Bundlecalmandbloomhd.png?v=1790011638',
    url: '/products/bundle-calm-bloom-3-pack',
    variantId: '58788735844726'
  };
  const FIVE_PACK = {
    eyebrow: 'Upgrade to all 5 · Biggest saving',
    title: 'All 5 Filters',
    benefit: 'You already have a 3-pack — complete the set with all 5 scents, no duplicates.',
    price: '<span class="money">Dhs. 476.00</span>',
    compare: '<span class="money">Dhs. 595.00</span>',
    saving: 'Save <span class="money">Dhs. 119.00</span>',
    image: 'https://cdn.shopify.com/s/files/1/0913/2880/7286/files/Naia-bundle-5-produkter-HD_Cherry.png?v=1792073723',
    url: '/products/all-5-filters',
    variantId: '58505707848054'
  };
  // Any 3-pack in the cart triggers the 5-pack upsell.
  const THREE_PACK_IDS = [58788735844726, 58788737319286];
  // Any 5-pack already in the cart hides the upsell.
  const FIVE_PACK_IDS = [58505707848054, 58506450305398];

  // The bundle currently shown in the drawer (set by inject()).
  let active = THREE_PACK;

  function injectStyles() {
    if (document.getElementById('NaiaCartUpsellsStyles')) return;
    const style = document.createElement('style');
    style.id = 'NaiaCartUpsellsStyles';
    style.textContent = `
      .naia-cart-upsells{padding:4px 20px 14px;font-family:var(--font-body-family)}
      .naia-cart-upsells__heading{margin:0 0 8px;font-size:11px;line-height:1;font-weight:700;letter-spacing:.09em;color:rgba(36,35,33,.5);text-transform:uppercase}
      .naia-cart-bundle{display:flex;align-items:center;gap:12px;padding:10px 12px;border:1px solid rgba(36,35,33,.1);border-radius:12px;background:linear-gradient(180deg,#fff,#faf5ef)}
      .naia-cart-bundle__image{width:50px;height:50px;object-fit:contain;flex:0 0 50px;filter:drop-shadow(0 6px 10px rgba(36,35,33,.08));transition:transform .35s ease,opacity .35s ease}
      .naia-cart-bundle__copy{min-width:0;flex:1;display:flex;flex-direction:column;gap:3px}
      .naia-cart-bundle__title{font-size:13px;line-height:1.15;font-weight:600;letter-spacing:-.01em;color:#242321;text-decoration:none;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}
      .naia-cart-bundle__pricing{display:flex;align-items:baseline;gap:6px;flex-wrap:wrap}
      .naia-cart-bundle__price{font-size:13px;font-weight:700;color:#242321}
      .naia-cart-bundle__compare{font-size:10px;color:rgba(36,35,33,.4);text-decoration:line-through}
      .naia-cart-bundle__saving{font-size:10px;font-weight:700;color:#5c7a58}
      .naia-cart-bundle__button{flex:0 0 auto;margin:0;padding:9px 16px;border:1px solid #242321;border-radius:999px;background:#242321;color:#fff;font-size:11px;line-height:1;font-weight:700;letter-spacing:.08em;text-transform:uppercase;cursor:pointer;appearance:none;-webkit-appearance:none;transition:background .2s ease,transform .2s ease}
      .naia-cart-bundle__button:active{transform:scale(.96)}
      .naia-cart-bundle__button[aria-busy="true"]{opacity:.7}
      .naia-cart-flyer{position:fixed;z-index:2147483647;pointer-events:none;margin:0;object-fit:contain;transform-origin:center center;will-change:transform,opacity;filter:drop-shadow(0 16px 24px rgba(36,35,33,.24))}
      .naia-cart-pulse{position:fixed;z-index:2147483646;width:30px;height:30px;border:1px solid rgba(36,35,33,.45);border-radius:50%;pointer-events:none;transform:translate(-50%,-50%) scale(.35);opacity:0;animation:naiaCartPulse .55s cubic-bezier(.2,.8,.2,1) forwards}
      @keyframes naiaCartPulse{0%{opacity:0;transform:translate(-50%,-50%) scale(.35)}25%{opacity:.8}100%{opacity:0;transform:translate(-50%,-50%) scale(1.35)}}
      @media(max-width:749px){.naia-cart-upsells{padding:4px 16px 13px}}
    `;
    document.head.appendChild(style);
  }

  function findFirstCartItemImage(drawer) {
    const firstRow = drawer?.querySelector('.cart-items tbody tr.cart-item');
    return firstRow?.querySelector('.cart-item__image') || null;
  }

  async function refreshDrawerAndFindTarget(response) {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer) return null;
    if (typeof drawer.renderContents === 'function' && response?.sections) {
      try { drawer.renderContents(response); } catch(e) {}
    }
    if (typeof drawer.open === 'function') {
      try { drawer.open(); } catch(e) {}
    }
    await new Promise(resolve => requestAnimationFrame(() => requestAnimationFrame(resolve)));
    return findFirstCartItemImage(drawer);
  }

  function flyToTarget(sourceRect, targetImage) {
    return new Promise((resolve) => {
      if (!sourceRect || !targetImage) { resolve(); return; }

      const end = targetImage.getBoundingClientRect();
      if (!end.width || !end.height) { resolve(); return; }

      const flyer = document.createElement('div');
      flyer.className = 'naia-cart-flyer';
      flyer.innerHTML = '<img src="' + active.image + '" alt="">';

      Object.assign(flyer.style, {
        position: 'fixed',
        left: sourceRect.left + 'px',
        top: sourceRect.top + 'px',
        width: Math.max(sourceRect.width, 50) + 'px',
        height: Math.max(sourceRect.height, 50) + 'px',
        zIndex: '2147483647',
        pointerEvents: 'none',
        margin: '0',
        opacity: '1',
        visibility: 'visible',
        display: 'block',
        transform: 'translate3d(0,0,0) scale(1)',
        transformOrigin: 'center center',
        willChange: 'transform, opacity',
        transition: 'none'
      });

      const img = flyer.querySelector('img');
      Object.assign(img.style, {
        display:'block',
        width:'100%',
        height:'100%',
        objectFit:'contain',
        opacity:'1',
        visibility:'visible',
        filter:'drop-shadow(0 18px 28px rgba(0,0,0,.28))'
      });

      document.body.appendChild(flyer);

      const sx = sourceRect.left + sourceRect.width / 2;
      const sy = sourceRect.top + sourceRect.height / 2;
      const tx = end.left + end.width / 2;
      const ty = end.top + end.height / 2;
      const dx = tx - sx;
      const dy = ty - sy;

      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          flyer.style.transition = 'transform 1050ms cubic-bezier(.16,1,.3,1), opacity 1050ms ease';
          flyer.style.transform = 'translate3d(' + dx + 'px,' + dy + 'px,0) scale(.18)';
          flyer.style.opacity = '0.05';
        });
      });

      window.setTimeout(() => {
        flyer.remove();
        const pulse = document.createElement('span');
        pulse.className = 'naia-cart-pulse';
        pulse.style.left = tx + 'px';
        pulse.style.top = ty + 'px';
        document.body.appendChild(pulse);
        window.setTimeout(() => pulse.remove(), 650);
        resolve();
      }, 1100);
    });
  }

  async function getCart() {
    const root = window.Shopify?.routes?.root || '/';
    const response = await fetch(root + 'cart.js', {
      credentials: 'same-origin',
      headers: {'Accept':'application/json'}
    });
    if (!response.ok) throw new Error('Unable to read cart');
    return response.json();
  }

  function cartHasAny(cart, ids) {
    return !!cart?.items?.some(item => ids.indexOf(Number(item.variant_id)) !== -1);
  }

  // Decide which bundle (if any) to show, based on the current cart.
  async function resolveBundle() {
    let cart;
    try { cart = await getCart(); } catch (e) { return THREE_PACK; }
    if (cartHasAny(cart, FIVE_PACK_IDS)) return null;       // already has a 5-pack
    if (cartHasAny(cart, THREE_PACK_IDS)) return FIVE_PACK;  // upgrade a 3-pack to 5
    return THREE_PACK;                                       // default entry offer
  }

  async function addBundle(button) {
    if (!button || button.dataset.loading === 'true' || button.disabled) return;

    button.dataset.loading = 'true';
    button.setAttribute('aria-busy','true');
    const original = button.textContent;
    button.textContent = 'Adding…';

    const card = button.closest('.naia-cart-bundle');
    const sourceImage = card?.querySelector('.naia-cart-bundle__image');
    const sourceRect = sourceImage?.getBoundingClientRect();

    try {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(root + 'cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {'Content-Type':'application/json','Accept':'application/json'},
        body: JSON.stringify({
          items:[{id:Number(active.variantId),quantity:1}],
          sections:'cart-drawer,cart-icon-bubble',
          sections_url:window.location.pathname
        })
      });

      const data = await response.json();
      if (!response.ok) throw new Error(data.description || data.message || 'Unable to add bundle');

      const targetImage = await refreshDrawerAndFindTarget(data);

      if (sourceRect && targetImage) {
        await flyToTarget(sourceRect, targetImage);
      }

      // Re-evaluate: adding a 3-pack now offers the 5-pack; adding the 5-pack hides the upsell.
      lastVariantId = null;
      schedule();
    } catch (error) {
      console.error('Naia bundle add failed:', error);
      button.textContent = 'Try again';
      button.removeAttribute('aria-busy');
      delete button.dataset.loading;
      window.setTimeout(() => {
        if (button.isConnected) button.textContent = original;
      }, 1400);
    }
  }

  window.NaiaAddBundle = addBundle;

  function markup(bundle) {
    return `
      <h3 class="naia-cart-upsells__heading">Save &amp; Bundle</h3>
      <div class="naia-cart-bundle">
        <img class="naia-cart-bundle__image" src="${bundle.image}" alt="${bundle.title}" loading="lazy">
        <div class="naia-cart-bundle__copy">
          <a class="naia-cart-bundle__title" href="${bundle.url}">${bundle.title}</a>
          <div class="naia-cart-bundle__pricing"><span class="naia-cart-bundle__price">${bundle.price}</span><span class="naia-cart-bundle__compare">${bundle.compare}</span><span class="naia-cart-bundle__saving">${bundle.saving}</span></div>
        </div>
        <button type="button" class="naia-cart-bundle__button" id="NaiaAddBundle" onclick="window.NaiaAddBundle(this); return false;">Add</button>
      </div>`;
  }

  let lastVariantId = null;
  let injectPending = false;

  // Insert or update the upsell wrapper WITHOUT flicker.
  function placeWrapper(inner, footer, bundle) {
    if (!inner || !footer || !bundle) return;
    const current = inner.querySelector('#NaiaCartUpsells');
    if (current && current.dataset.bundle === String(bundle.variantId)) return;
    active = bundle;
    lastVariantId = bundle.variantId;
    const wrapper = document.createElement('div');
    wrapper.id = 'NaiaCartUpsells';
    wrapper.className = 'naia-cart-upsells';
    wrapper.dataset.bundle = bundle.variantId;
    wrapper.innerHTML = markup(bundle);
    if (current) current.replaceWith(wrapper);
    else inner.insertBefore(wrapper, footer);
  }

  async function inject() {
    const drawer = document.querySelector('cart-drawer');
    const inner = drawer?.querySelector('.drawer__inner');
    const footer = inner?.querySelector('.drawer__footer');
    const items = drawer?.querySelector('cart-drawer-items');

    if (!inner || !footer || !items || items.classList.contains('is-empty') || drawer.classList.contains('is-empty')) {
      const existing = inner?.querySelector('#NaiaCartUpsells');
      if (existing) existing.remove();
      lastVariantId = null;
      return;
    }

    // Instant, synchronous re-insert of the cached bundle if a cart re-render just
    // wiped the wrapper. This removes the visible "reload" gap on every add/qty change.
    if (active && !inner.querySelector('#NaiaCartUpsells')) {
      placeWrapper(inner, footer, active);
    }

    if (injectPending) return;
    injectPending = true;
    let bundle;
    try { bundle = await resolveBundle(); }
    finally { injectPending = false; }

    const drawer2 = document.querySelector('cart-drawer');
    const inner2 = drawer2?.querySelector('.drawer__inner');
    const footer2 = inner2?.querySelector('.drawer__footer');
    if (!inner2 || !footer2) return;

    const current = inner2.querySelector('#NaiaCartUpsells');
    // No bundle to show (e.g. cart already has a 5-pack): clear the cache so the
    // instant re-insert above does NOT keep re-adding it (which caused an add/remove loop).
    if (!bundle) { active = null; lastVariantId = null; if (current) current.remove(); return; }

    placeWrapper(inner2, footer2, bundle);
  }

  let scheduleTimer = null;
  function schedule() { clearTimeout(scheduleTimer); scheduleTimer = setTimeout(inject, 16); }

  const observer = new MutationObserver(() => schedule());

  function init() {
    injectStyles();
    inject();
    const drawer = document.querySelector('cart-drawer');
    if (drawer) observer.observe(drawer, {childList:true, subtree:true});
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true});
  else init();
})();
